import React, { useEffect, useState } from 'react'
import { Row } from 'react-bootstrap'
import AppFormikInputInline from 'utlis/helpers/forms/AppFormikInputInline';
import AppFormikSelectInline from 'utlis/helpers/forms/AppFormikSelectInline';
import { setGlobalLoading } from 'redux/actions/actionCommon';
import { connect } from 'react-redux';
import { getCustomerCities, getCustomerStates } from 'utlis/Apis/Customers_API';
import { ERROR_WHILE__NAME } from 'utlis/AppMessages/AppMessages';
import { UNKNOWN_ERROR_OCCURED } from 'utlis/AppMessages/AppMessages';
import { toast } from 'react-toastify';

function FormSaleAddress(props) {
    const { countries, formik } = props
    const [states, setStates] = useState([])
    const [cities, setCities] = useState([])

    useEffect(() => {
        const { shipping_country, shipping_state } = formik.values || {}
        if (shipping_country) {
            getStates_(shipping_country)
        }
        if (shipping_state) {
            getCities_(shipping_state)
        }
    }, [formik.values.shipping_country])
    const getStates_ = (country_id) => {
        setStates([])
        setCities([])
        getCustomerStates(country_id).then(res => {
            const stateData = res.data
            if (stateData.success) {
                setStates(stateData.data)
            }

            if (stateData.error) {
                console.log('Error occured while loading states!', res)
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getStates `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500
            })
        })
    }

    const getCities_ = (region_id) => {
        setCities([])
        getCustomerCities(region_id).then(res => {
            const cityData = res.data
            if (cityData.success) {
                setCities(cityData.data)
            }

            if (cityData.error) {
                console.log('Error occured while loading cities!', res)
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getCities `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
            })
        })
    }
    return (
        <React.Fragment>
            <AppFormikInputInline
                formik={formik}
                stFormClass={" st-form-with-label-left d-flex flex-wrap align-items-center mb-3"}
                labelName={"First Name"}
                isRequired={true}
                placeholder={"First Name"}
                formikFieldName={"shipping_first_name"}
            />

            <AppFormikInputInline
                formik={formik}
                stFormClass={" st-form-with-label-left d-flex flex-wrap align-items-center mb-3"}
                labelName={"Middle Name"}
                isRequired={false}
                placeholder={"Middle Name"}
                formikFieldName={"shipping_middle_name"}
            />

            <AppFormikInputInline
                formik={formik}
                stFormClass={" st-form-with-label-left d-flex flex-wrap align-items-center mb-3"}
                labelName={"Last Name"}
                isRequired={true}
                placeholder={"Last Name"}
                formikFieldName={"shipping_last_name"}
            />

            <AppFormikInputInline
                formik={formik}
                stFormClass={" st-form-with-label-left d-flex flex-wrap align-items-center mb-3"}
                labelName={"Company Name"}
                isRequired={false}
                placeholder={"Company Name"}
                formikFieldName={"shipping_company_name"}
            />
            <AppFormikInputInline
                formik={formik}
                stFormClass={" st-form-with-label-left d-flex flex-wrap align-items-cente mb-3"}
                labelName={"Street Address"}
                isRequired={true}
                placeholder={"Street Address1"}
                formikFieldName={"shipping_address"}
            />
            <div className="d-flex justify-content-end">
                <Row className="justify-content-end" style={{ width: "56%" }}>
                    <AppFormikInputInline
                        formik={formik}
                        stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center mb-3"}
                        labelName={""}
                        isRequired={false}
                        placeholder={"Street Address2"}
                        formikFieldName={"shipping_address1"}
                    />
                </Row>
            </div>
            <AppFormikSelectInline
                formik={formik}
                stFormClass={" st-form-with-label-left d-flex flex-wrap align-items-center"}
                labelName={"Country"}
                isRequired={true}
                formikFieldName={"shipping_country"}
                onChange={(country) => {
                    getStates_(country)
                    formik.setFieldValue("shipping_state", "")
                    formik.setFieldValue("shipping_city", "")
                }}
                disabled={countries.length === 0}
            >
                <option disabled value="">Select Country</option>
                {(countries && countries.length) && countries.map(item => (
                    <option
                        key={item.country_id.toString()}
                        value={item.country_id.toString()}>{item.country}</option>
                ))
                }
            </AppFormikSelectInline>

            <AppFormikSelectInline
                formik={formik}
                stFormClass={" st-form-with-label-left d-flex flex-wrap align-items-center mb-3"}
                labelName={"State/Provience"}
                isRequired={true}
                formikFieldName={"shipping_state"}
                onChange={(state) => {
                    getCities_(state)
                    formik.setFieldValue("shipping_city", "")
                }}
                disabled={states.length === 0}
            >
                <option disabled value="">Select State</option>
                {(states && states.length) && states.map(item => (
                    <option
                        key={item.region_id.toString()}
                        value={item.region_id.toString()}>{item.region}</option>
                ))
                }
            </AppFormikSelectInline>

            <AppFormikSelectInline
                formik={formik}
                stFormClass={" st-form-with-label-left d-flex flex-wrap align-items-center mb-3"}
                labelName={"City"}
                isRequired={true}
                formikFieldName={"shipping_city"}
                disabled={cities.length === 0}
            >
                <option disabled value="">Select City</option>
                {(cities && cities.length) && cities.map(item => (
                    <option
                        key={item.city_id.toString()}
                        value={item.city_id.toString()}>{item.city}</option>
                ))
                }
            </AppFormikSelectInline>

            <AppFormikInputInline
                formik={formik}
                stFormClass={" st-form-with-label-left d-flex no-arrows flex-wrap align-items-center mb-3"}
                labelName={"Zip/Postal Code"}
                isRequired={false}
                inputType={"number"}
                placeholder={"ZipCode"}
                formikFieldName={"shipping_zipcode"}
            />

            {/* <AppFormikInputInline
                formik={formik}
                stFormClass={" st-form-with-label-left no-arrows d-flex flex-wrap align-items-center mb-3"}
                labelName={"Phone Number"}
                inputType="phone"
                isRequired={false}
                placeholder={"Phone"}
                formikFieldName={"shipping_phone"}

            /> */}
            <AppFormikInputInline
                formik={formik}
                stFormClass={" st-form-with-label-left no-arrows d-flex flex-wrap align-items-center mb-3"}
                labelName={"Mobile"}
                inputType="phone"
                isRequired={true}
                placeholder={"Mobile"}
                formikFieldName={"shipping_mobile"}
            />

            <AppFormikInputInline
                formik={formik}
                stFormClass={" st-form-with-label-left d-flex no-arrows flex-wrap align-items-center mb-3"}
                labelName={"Fax"}
                isRequired={false}
                placeholder={"Fax"}
                inputType={"number"}
                formikFieldName={"shipping_fax"}
            />
        </React.Fragment>
    )
}

const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser,
        sideBarVisibility: state.common.sideBarVisibility
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(FormSaleAddress)
